<template>
    <section class="footer mt-auto text-center text-neutral-200 text-base mb-4 px-5">
        <p>&copy;  2023 Sven Ingar Frantzen - All Rights Reserved.</p>
    </section>
</template>
<script>
export default {
    
}
</script>